import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuenMoushikomiItsukara: BlogMetaData = {
  title: '保育園の申し込みはいつから？申請時期の目安・必要書類・自治体確認の手順',
  description:
    '保育園の申し込みはいつから？4月入園・途中入園の申請時期の考え方、募集要項の確認方法、必要書類の例、見学と並行して進めるコツを手順で解説。自治体ごとの違いを前提にした確認チェックリスト付きです。',
  thumbnailUrl: '/img/blog-hoikuen-moushikomi-itsukara.webp',
  filePath: buildBlogFilePath('hoikuen-moushikomi-itsukara'),
  category: BLOG_CATEGORY.NURSERY,
};
